export const UPDATE = "UPDATE";
export const DRAGSTART = "STARTDRAG";
export const DRAGMOVE = "DRAGMOVE";
export const DRAGEND = "STARTEND";
export const UPDATEWIDTH = "UPDATEWIDTH";